const Image = ({image, maxWidth = ""}) => {
    return !!image && <img src={image.url} alt={image.alt || image.label} style={!!maxWidth ? { maxWidth } : {}}/>
}

export default Image